var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('div',{attrs:{"id":"map"}}),_vm._v(" "),_c('div',{staticClass:"float-right mt-2"},[_c('button',{staticClass:"btn btn-primary rounded mr-1 btn-lg",attrs:{"type":"button"},on:{"click":_vm.closeMap}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary rounded btn-lg",attrs:{"type":"button"},on:{"click":_vm.saveTradezone}},[_vm._v("Save")])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69588b5b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/outlets/OutletsMap.vue
// module id = 1819
// module chunks = 0